import { z } from 'zod';

import { zodBlockerSchema } from '../validations';

export const zodCompanyMoveCheckPathSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('companies'),
  z.uuid(),
  z.literal('move_check'),
]);

export const zodCompanyMoveCheckSearchParamsSchema = z.object({
  targetCompanyAccountId: z.uuid().optional(),
});

export const zodCompanyMoveCheckResponseSchema = z.object({
  blockers: z.array(zodBlockerSchema),
  movable: z.boolean(),
});
